import styled from "styled-components";
import {Colors} from "@brg/ui";
import { CoreContainer, LayoutConst } from "core";

export const SchedulePageWrapper = styled(CoreContainer)`
    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: 1152px; 
    }
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        width: ${LayoutConst.container.m + 'px'}; 
    }
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.container.s + 'px'}; 
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        width: 320px; 
    }
        
`
export const NearLessonLeftPart = styled.div<{isLessonTeacher?: boolean}>`
    display: flex;
    background: #5C97FF;
    padding: 8px 16px;
    align-items: ${({isLessonTeacher}) => isLessonTeacher ? 'flex-end': 'center'};
    gap: 24px;
    border-radius: 3px 0 0 3px;
    flex: 1 1 33.33%;
    
    color: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        padding: 6px 12px;
        max-width: 257px;
    }

    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        border-radius: 8px 8px 0 0;
        justify-content: space-between;
        max-width: none;
    }
`
export const NearLessonLeftPartTitle = styled.div`
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    text-wrap: nowrap;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 10px;
        line-height: 13px;
    }
`
export const NearLessonLeftPartTime = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    text-wrap: nowrap;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 15px;
        line-height: 20px;
    }
`
export const NearLessonTeach = styled.div`
    font-size: 10px;
    font-weight: 600;
    line-height: 13px; 
    letter-spacing: -0.2px;
    padding: 3px 16px;
    color: #FEFEFE;
    background: #E75728;
    border-radius: 0px 4px 4px 0px;
    max-width: 85px;
    margin-left: -16px;
    margin-bottom: 8px;
     @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin-left: -12px;
    }
`
export const NearLessonButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    background: ${Colors.geoWhite100};
    color: ${Colors.galBlack100};
    border-radius: 3px;
    width: 88px;
    height: 28px;
    cursor: pointer;

    @media (max-width: ${LayoutConst.screen.s - 1 +'px'}) {
        height: 26px;
    }
`

export const NearLessonRightPart = styled.div<{ fullWidth?: boolean }>`
    width: 100%;
    background: ${Colors.galBlack5};
    border-radius: 0 3px 3px 0;
    display: flex;
    align-items: center;
    padding-right: ${({ fullWidth }) => fullWidth ? '0px' : '16px'};
    flex: 2 1 66.67%;
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: 455px; 
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${({ fullWidth }) => fullWidth ? '100%' : '320px'}; 
        border-radius: 0 0 8px 8px;
        padding: 8px 16px;
    }
`

export const NearLessonRightPartItem = styled.div`
    max-width: 280px;
    padding: 2px 4px;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    color: ${Colors.galBlack47};
    display: flex;
    gap: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 10px;
        max-width: 210px;
    }
    
    span {
        font-weight: 600;
        color: ${Colors.galBlack73};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;  
    }
`

export const DateSwitcherArrowWrapper = styled.div<{ isRight?: boolean }>`
    display: flex;
    align-items: center;
    cursor: pointer;
    transform: rotate(${({isRight}) => isRight ? 180 : 0}deg);

    svg {
        width: 16px;
        height: 16px;
        
        path {
            fill: ${Colors.galBlack47}
        }
    }
`

export const DateSwitcherText = styled.div`
    color: ${Colors.galBlack100};
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    margin: 0 8px;
`

export const ScheduleLessonTableWrapper = styled.div`
    width: 100%;
`

export const ScheduleLessonHeaderWrapper = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 116px 250px 85px 145px 115px 150px;
    border-bottom: 1px solid ${Colors.galBlack47};
     @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        grid-template-columns: 75px 210px 60px 110px 90px 105px;
    }
`
export const ScheduleLessonHeaderItem = styled.div`
    color: ${Colors.galBlack47};
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    padding: 10px 16px;
`

export const ScheduleLessonTableItemWrapper = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 116px 250px 85px 145px 115px 150px;
    border-bottom: 1px solid ${Colors.galBlack21};
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        grid-template-columns: 75px 210px 60px 110px 90px 105px;
    }
`
export const ScheduleLessonItem = styled.div<{isButtom?: boolean}>`
    color: ${Colors.galBlack100};
    padding: ${({isButtom}) => isButtom ? '18px 0px' : '18px 16px'};
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: column;
    gap: 2px;
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        padding: ${({isButtom}) => isButtom ? '18px 0px' : '18px 12px'};
    }
    
    span {
        font-size: 11px;
        font-weight: 400;
        line-height: 13px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: pre-wrap;
        color: ${Colors.galBlack47};
    }
`
export const ScheduleLessonTableButton = styled.div`
    cursor: pointer;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    padding: 4px 15px;
    border-radius: 3px;
    background: ${Colors.galBlack100};
`import styled from "styled-components";
import {Colors} from "@brg/ui";
import { CoreContainer, LayoutConst } from "core";

export const SchedulePageWrapper = styled(CoreContainer)`
    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        width: 1152px; 
    }
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        width: ${LayoutConst.container.m + 'px'}; 
    }
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: ${LayoutConst.container.s + 'px'}; 
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        width: 320px; 
    }
        
`
export const NearLessonLeftPart = styled.div<{isLessonTeacher?: boolean}>`
    display: flex;
    background: #5C97FF;
    padding: 8px 16px;
    align-items: ${({isLessonTeacher}) => isLessonTeacher ? 'flex-end': 'center'};
    gap: 24px;
    border-radius: 3px 0 0 3px;
    flex: 1 1 33.33%;
    
    color: ${Colors.geoWhite100};

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        padding: 6px 12px;
        max-width: 257px;
    }

    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        border-radius: 8px 8px 0 0;
        justify-content: space-between;
        max-width: none;
    }
`
export const NearLessonLeftPartTitle = styled.div`
    font-size: 11px;
    line-height: 13px;
    font-weight: 600;
    text-wrap: nowrap;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 10px;
        line-height: 13px;
    }
`
export const NearLessonLeftPartTime = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    text-wrap: nowrap;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 15px;
        line-height: 20px;
    }
`
export const NearLessonTeach = styled.div`
    font-size: 10px;
    font-weight: 600;
    line-height: 13px; 
    letter-spacing: -0.2px;
    padding: 3px 16px;
    color: #FEFEFE;
    background: #E75728;
    border-radius: 0px 4px 4px 0px;
    max-width: 85px;
    margin-left: -16px;
    margin-bottom: 8px;
     @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        margin-left: -12px;
    }
`
export const NearLessonButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    background: ${Colors.geoWhite100};
    color: ${Colors.galBlack100};
    border-radius: 3px;
    width: 88px;
    height: 28px;
    cursor: pointer;

    @media (max-width: ${LayoutConst.screen.s - 1 +'px'}) {
        height: 26px;
    }
`

export const NearLessonRightPart = styled.div<{ fullWidth?: boolean }>`
    width: 100%;
    background: ${Colors.galBlack5};
    border-radius: 0 3px 3px 0;
    display: flex;
    align-items: center;
    padding-right: ${({ fullWidth }) => fullWidth ? '0px' : '16px'};
    flex: 2 1 66.67%;
    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        width: 455px; 
    }
    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        width: ${({ fullWidth }) => fullWidth ? '100%' : '320px'}; 
        border-radius: 0 0 8px 8px;
        padding: 8px 16px;
    }
`

export const NearLessonRightPartItem = styled.div`
    max-width: 280px;
    padding: 2px 4px;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    color: ${Colors.galBlack47};
    display: flex;
    gap: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 10px;
        max-width: 210px;
    }
    
    span {
        font-weight: 600;
        color: ${Colors.galBlack73};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;  
    }
`

export const DateSwitcherArrowWrapper = styled.div<{ isRight?: boolean }>`
    display: flex;
    align-items: center;
    cursor: pointer;
    transform: rotate(${({isRight}) => isRight ? 180 : 0}deg);

    svg {
        width: 16px;
        height: 16px;
        
        path {
            fill: ${Colors.galBlack47}
        }
    }
`

export const DateSwitcherText = styled.div`
    color: ${Colors.galBlack100};
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    margin: 0 8px;
`

export const ScheduleLessonTableWrapper = styled.div`
    width: 100%;
`

export const ScheduleLessonHeaderWrapper = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 116px 250px 85px 145px 115px 150px;
    border-bottom: 1px solid ${Colors.galBlack47};
     @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        grid-template-columns: 75px 210px 60px 110px 90px 105px;
    }
`
export const ScheduleLessonHeaderItem = styled.div`
    color: ${Colors.galBlack47};
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    padding: 10px 16px;
`

export const ScheduleLessonTableItemWrapper = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 116px 250px 85px 145px 115px 150px;
    border-bottom: 1px solid ${Colors.galBlack21};
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        grid-template-columns: 75px 210px 60px 110px 90px 105px;
    }
`
export const ScheduleLessonItem = styled.div<{isButtom?: boolean}>`
    color: ${Colors.galBlack100};
    padding: ${({isButtom}) => isButtom ? '18px 0px' : '18px 16px'};
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: 100%;
    flex-direction: column;
    gap: 2px;
    @media (max-width: ${LayoutConst.screen.m_1024 + 'px'}) {
        padding: ${({isButtom}) => isButtom ? '18px 0px' : '18px 12px'};
    }
    
    span {
        font-size: 11px;
        font-weight: 400;
        line-height: 13px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: pre-wrap;
        color: ${Colors.galBlack47};
    }
`
export const ScheduleLessonTableButton = styled.div`
    cursor: pointer;
    color: ${Colors.geoWhite100};
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    padding: 4px 15px;
    border-radius: 3px;
    background: ${Colors.galBlack100};
`